// extracted by mini-css-extract-plugin
module.exports = {"linkLiContainer":"FullWidthTextLink_linkLiContainer__ex76_","linkBtn":"FullWidthTextLink_linkBtn___7Sjd","linkIcon":"FullWidthTextLink_linkIcon__pkoGr"};